'use client'

import { css } from '@lastbrand/web-ui-styled-system/css'

import { BreadcrumbsDS } from '@src/components/blocks/breadcrumb-ds'
import { SectionContentContainer } from '@src/ds/blocks/section-content-container'

import { BreadcrumbsPdpVariantProps } from './breadcrumbs-pdp.types'

// Block padding only — `SectionContentContainer` owns the horizontal frame, which is what lines the
// crumb up with the gallery's left edge. Mobile is space-8 so the strip lands at the Figma
// PageTitle spec's 40px (STRFRNT-16793); lg keeps the 48px zone the form column compensates for.
const dsSpacingClass = css({
  paddingBlock: { base: 'space-8', lg: 'space-16' },
})

// Left-aligns below `lg` without `isPDP`, whose bare-gallery gutters would double-inset us here.
// The PDP desktop crumb is body-12 per Figma (Widget-PageTitle 9346:28513) — `isPDP` would set it
// but also leak the bare-gallery px/py; inject just the textStyle via the css prop instead, which
// BreadcrumbsDS merges after its own deviceType branch (STRFRNT-16751).
// eslint-disable-next-line i18next/no-literal-string -- Panda layout/text tokens (not user-facing copy)
const dsNavCss = { marginInlineEnd: 'auto', lg: { textStyle: 'body-12' } } as const

export function BreadcrumbsPdpDSWidget({ directory, deviceType, testId }: BreadcrumbsPdpVariantProps) {
  return (
    <SectionContentContainer data-testid={testId} className={dsSpacingClass}>
      <BreadcrumbsDS directory={directory} deviceType={deviceType} css={dsNavCss} />
    </SectionContentContainer>
  )
}
